// extracted by mini-css-extract-plugin
module.exports = {"post_body_grid":"styles_post_body_grid__29han","reactionsDesktop":"styles_reactionsDesktop__wvINU"};